// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Bp-z","breadcrumbForward":"Cp-z","breadcrumbBack":"Dp-z","selected":"Ep-z"};